import React from 'react'
import { Col, Flex, Row, Typography } from 'antd'
import { UnderlineDesign } from '../UnderlineDesign'


const { Text, Title } = Typography
const Prosection = () => {

    const valuesData = [
        {
            icon: 'speed-meter.png',
            title: 'Fast Response',
            desc: "We fully committed to making sure you're completely satisfied. If there’s anything more we  can do or adjust, just let me know—your satisfaction is our top priority.",
        },
        {
            icon: 'promotion.png',
            title: 'World Class Job',
            desc: "Our mission is simple: to exceed your expectations. Whether you're here for inspiration, services, or solutions, We committed to providing an exceptional experience tailored to your needs. ",
        },
        {
            icon: 'quality-service.png',
            title: 'Best Quality',
            desc: "Every detail matters—because you matter. We dedicated to delivering only the highest quality in everything We offer. From the moment you land on this site to the final result, my focus is on making sure you're not just satisfied, but genuinely impressed. Excellence isn't an option here—it's the foundation.",
        },
    ]

  return (
    <div className='py-4 mt-3 bg-light'>
        <div className='container'>
            <Row gutter={[24, 24]} align={'middle'}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <Flex vertical gap={30}>
                        <Flex vertical>
                            <Title level={2} className='m-0 gradient-text'>
                                Find a Pro you'll love with the UK's
                            </Title>
                            <UnderlineDesign />
                        </Flex>
                        <Row gutter={[33, 33]}>
                            {
                                valuesData?.map((item, index) => (
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 20 }} key={index}>
                                        <Flex gap={10}>
                                            <div>
                                                <img src={`assets/icons/` + item?.icon} width={35} height={35} alt="" />
                                            </div>
                                            <div>
                                                <Title level={4} className='m-0'>{item?.title}</Title>
                                                <Text>{item?.desc}</Text>
                                            </div>
                                        </Flex>
                                    </Col>
                                ))
                            }

                        </Row>

                    </Flex>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <div>
                        <img src="assets/images/values.jpg" width={'100%'} className='rounded' alt="" />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {Prosection}